import { filter } from "@/assets";
import { DataTable } from "@/components";
import { Button } from "@/components/ui";
import { Filter } from "./Filter";
import useSubmodule from "./useSubmodule";

const Submodule = () => {
  const {
    columns,
    onAdd,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    isPending,
    isError,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  } = useSubmodule();

  return (
    <>
      <div className="mb-4 px-5 flex justify-end gap-3">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} />
          Filter
        </Button>
        <Button onClick={onAdd}>+ Add New</Button>
      </div>
      {isPending && <div className="px-5 py-3">Loading...</div>}
      {!isPending && !isError && (
        <DataTable
          columns={columns}
          data={tableData}
          serviceSidePagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      )}
      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </>
  );
};

export default Submodule;
